/**
 * Ordering for the Platform Health org list.
 *
 * Extracted as a pure function for the same reason as `chooseAuthScreen`: this
 * console has no DOM test harness, and the ordering is the part with a decision
 * in it. Dark orgs first — an org with agents and none connected is a customer
 * with no monitoring, and it must not sit somewhere down an alphabetical list.
 * Alphabetical within each band so the list is stable between 30s polls.
 */
const RANK = { down: 0, degraded: 1, healthy: 2 };

export function sortOrgsByHealth(orgs) {
  return [...(orgs || [])].sort(
    (a, b) =>
      (RANK[a.health] ?? 3) - (RANK[b.health] ?? 3) ||
      String(a.org_name).localeCompare(String(b.org_name)),
  );
}
